import { ReactNode } from 'react';

interface SectionHeaderProps {
  eyebrow?: string;
  title: ReactNode;
  subtitle?: string;
  align?: 'center' | 'left';
  /** Numbered section style, e.g. "01" — used on About / Service detail pages. */
  number?: string;
}

function SectionHeader({ eyebrow, title, subtitle, align = 'center', number }: SectionHeaderProps) {
  const className = align === 'left' ? 'section-header-left' : 'section-header-center';
  return (
    <div className={className}>
      {(number || eyebrow) && (
        <div className="section-header-eyebrow-row">
          {number && <span className="section-number">{number}</span>}
          {eyebrow && <span className="section-label">{eyebrow}</span>}
        </div>
      )}
      <h2 className="section-title">{title}</h2>
      {subtitle && <p className="section-subtitle">{subtitle}</p>}
    </div>
  );
}

export default SectionHeader;
